import React, { useState, useEffect } from "react";

import Table from "../../../common/Table";

import lbl from "../../../../data/Labels.json";
import calc from "../../../../utils/calculation";

const DataList = ({ data, currentTab }) => {
  const columns = {
    "Students Fee": [
      { path: "id", label: "شماره" },
      { path: "aria_id", label: "کد دانشجویی" },
      {
        path: "student_name",
        label: "نام",
      },
      { path: "student_father_name", label: "نام پدر" },
      { path: "class_desc", label: "صنف" },
      { path: "bank_ref_no", label: "ریفرنس نمبر" },
      { path: "account", label: "حساب" },
      { path: "amount", label: "مبلغ" },
    ],
    Grants: [
      { path: "id", label: "شماره" },
      { path: "sub_account", label: "نوع درامد" },
      { path: "received_by_staff", label: "دریافت کننده" },

      {
        path: "attachment",
        label: "سند",
        content: ({ attachment }) =>
          attachment && (
            <a href={attachment} download target="_blank">
              {lbl.Download}
            </a>
          ),
      },
      { path: "remark", label: "ملاحظه" },
      { path: "account", label: "حساب" },
      { path: "amount", label: "مبلغ" },
    ],
    "Academic Support": [
      { path: "id", label: "شماره" },
      { path: "sub_account", label: "نوع درامد" },
      { path: "received_by_staff", label: "دریافت کننده" },

      {
        path: "attachment",
        label: "سند",
        content: ({ attachment }) =>
          attachment && (
            <a href={attachment} download target="_blank">
              {lbl.Download}
            </a>
          ),
      },
      { path: "remark", label: "ملاحظه" },
      { path: "account", label: "حساب" },
      { path: "amount", label: "مبلغ" },
    ],
    Gifts: [
      { path: "id", label: "شماره" },
      { path: "sub_account", label: "نوع درامد" },
      { path: "received_by_staff", label: "دریافت کننده" },

      {
        path: "attachment",
        label: "سند",
        content: ({ attachment }) =>
          attachment && (
            <a href={attachment} download target="_blank">
              {lbl.Download}
            </a>
          ),
      },
      { path: "remark", label: "ملاحظه" },
      { path: "account", label: "حساب" },
      { path: "amount", label: "مبلغ" },
    ],
    "Misc Revenues": [
      { path: "id", label: "شماره" },
      { path: "sub_account", label: "نوع درامد" },
      { path: "received_by_staff", label: "دریافت کننده" },

      {
        path: "attachment",
        label: "سند",
        content: ({ attachment }) =>
          attachment && (
            <a href={attachment} download target="_blank">
              {lbl.Download}
            </a>
          ),
      },
      { path: "remark", label: "ملاحظه" },
      { path: "account", label: "حساب" },
      { path: "amount", label: "مبلغ" },
    ],
    "Teacher Salaries": [
      { path: "id", label: "شماره" },
      { path: "teacher_name", label: "نام" },
      { path: "payment_date", label: "تاریخ" },
      {
        path: "attachment",
        label: "سند",
        content: ({ attachment }) =>
          attachment && (
            <a href={attachment} download target="_blank">
              {lbl.Download}
            </a>
          ),
      },
      { path: "paid_by_staff_name", label: "پرداخت کننده" },
      { path: "modified_by_staff_name", label: "ثبت کننده" },
      { path: "remark", label: "ملاحظه" },
      { path: "amount", label: "مبلغ" },
    ],
    "Staff Salaries": [
      { path: "id", label: "شماره" },
      { path: "staff_name", label: "نام" },
      { path: "payment_date", label: "تاریخ" },
      {
        path: "attachment",
        label: "سند",
        content: ({ attachment }) =>
          attachment && (
            <a href={attachment} download target="_blank">
              {lbl.Download}
            </a>
          ),
      },
      { path: "paid_by_staff_name", label: "پرداخت کننده" },
      { path: "modified_by_staff_name", label: "ثبت کننده" },
      { path: "remark", label: "ملاحظه" },
      { path: "amount", label: "مبلغ" },
    ],
    "Direct Expenses": [
      { path: "id", label: "شماره" },
      { path: "sub_account", label: "نوع مصرف" },
      { path: "payment_date", label: "تاریخ پرداخت" },
      { path: "contractor", label: "طرف قرارداد" },
      { path: "paid_by_staff", label: "پرداخت کننده" },
      { path: "account", label: "حساب" },
      { path: "remark", label: "ملاحظه" },
      {
        path: "attachment",
        label: "سند",
        content: ({ attachment }) =>
          attachment && (
            <a href={attachment} download target="_blank">
              {lbl.Download}
            </a>
          ),
      },
      { path: "amount", label: "مبلغ" },
    ],
    "Indirect Expenses": [
      { path: "id", label: "شماره" },
      { path: "sub_account", label: "نوع مصرف" },
      { path: "payment_date", label: "تاریخ پرداخت" },
      { path: "contractor", label: "طرف قرارداد" },
      { path: "paid_by_staff", label: "پرداخت کننده" },
      { path: "account", label: "حساب" },
      { path: "remark", label: "ملاحظه" },
      {
        path: "attachment",
        label: "سند",
        content: ({ attachment }) =>
          attachment && (
            <a href={attachment} download target="_blank">
              {lbl.Download}
            </a>
          ),
      },
      { path: "amount", label: "مبلغ" },
    ],
    "Debt Payments": [
      { path: "id", label: "شماره" },
      { path: "creditor", label: "نام" },

      { path: "payment_date", label: "تاریخ" },
      {
        path: "attachment",
        label: "سند",
        content: ({ attachment }) =>
          attachment && (
            <a href={attachment} download target="_blank">
              {lbl.Download}
            </a>
          ),
      },
      { path: "paid_by_staff_name", label: "پرداخت کننده" },
      { path: "modified_by_staff_name", label: "ثبت کننده" },
      { path: "remark", label: "ملاحظه" },
      { path: "amount", label: "مبلغ" },
    ],
  };

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    let newData = { data, summary: { amount: calc.getTotal(data, "amount") } };

    setTableData(newData);
  }, [data]);

  return <Table data={tableData} columns={columns[currentTab?.name_en]} />;
};

export default DataList;
